module.exports = __webpack_public_path__ + "static/img/witness01.e374b5a.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/oldCode/witness01.png
// module id = 1231
// module chunks = 2